import React from 'react'

import Checkbox from '../../../pages/Settings/Controls/Checkbox'
import ArticleRow from './ArticleRow'

import { sortItems } from '../../../slices/article'
import useStyles from './styles'

const ArticleTable = ({ items = [] }) => {
  const classes = useStyles()

  return (
    <div className={classes.root} id='article-table-container'>
      <table className={classes.table}>
        <thead>
          <tr>
            <th>
              <Checkbox
                noBottomMargin
                reduceMarginRight
                onCheck={() => {}}
                variant='articleTable'
              />{' '}
              Folder/Article
            </th>

            <th>Status</th>

            <th>Created by</th>

            <th>Last edited</th>

            <th>Edited by</th>

            <th>Favorite</th>

            <th></th>
          </tr>
        </thead>

        <tbody>
          {sortItems(items).map(article => (
            <ArticleRow {...article} key={article.id} />
          ))}
        </tbody>
      </table>
    </div>
  )
}
export default ArticleTable
